import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider, DataTransformationProtocol } from "@tendercuts/http";
import { ProductSpec } from "@tendercuts/models";

@Injectable()
export class FetchProductSpecService
  extends BaseGetProvider<ProductSpec>
  implements DataTransformationProtocol {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof ProductSpec {
    return ProductSpec;
  }

  get endpoint(): string {
    return this.endpointService.fetchProductSpec();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    incrementId: string,
  ): {
    increment_id: string;
  } {
    const params: {
      increment_id: string;
    } = {
      increment_id: incrementId,
    };

    return params;
  }
}
